import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { AUTHENTICATED_HOME_ROUTE, createFileRoute, redirect } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';
import { validateSignUpLearnMoreSearch } from './-publicSearch';

const LazySignUpLearnMore = lazy(() =>
  import('./-sign-up-learn-more').then((module) => ({ default: module.SignUpLearnMore })),
);

const SignUpLearnMoreRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazySignUpLearnMore />
  </Suspense>
);

export const Route = createFileRoute('/sign-up/learn-more')({
  beforeLoad: async ({ context }) => {
    if (context.authentication?.isAuthenticated) {
      throw redirect({ to: AUTHENTICATED_HOME_ROUTE });
    }
  },
  component: SignUpLearnMoreRouteComponent,
  validateSearch: validateSignUpLearnMoreSearch,
});
